import React, { useState, useEffect } from 'react';

import API from './config';
import AdresseAutocomplete from './AdresseAutocomplete';
const COLORS = { bleu: '#1E3A5F', brun: '#7A4E2D', orange: '#F97316', vert: '#16A34A' };

export default function FicheClient({ apiFetch, clientId, affaires, devis, factures, peutEcrire=true, onRetour, onNouvelleAffaire, onModified, onOuvrirDevis, onOuvrirAffaire }) {
  const [clientData, setClientData] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [sectionsOuvertes, setSectionsOuvertes] = useState({ infos: false, adresses: false, contacts: false, notes: false });

  const toggleSection = (section) => setSectionsOuvertes(s => ({...s, [section]: !s[section]}));

  const charger = async () => {
    const r = await apiFetch(`${API}/clients/${clientId}`);
    if (r.ok) { const d = await r.json(); setClientData(d); setForm(d); }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { charger(); }, [clientId]);

  const showMsg = (msg) => { setMessage(msg); setTimeout(() => setMessage(''), 3000); };

  const sauvegarder = async () => {
    setSaving(true);
    const r = await apiFetch(`${API}/clients/${clientId}`, {
      method: 'PUT', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(form)
    });
    if (r.ok) { await charger(); setEditMode(false); showMsg('✅ Client mis à jour !'); if(onModified) onModified(); }
    else alert('Erreur lors de la mise à jour');
    setSaving(false);
  };

  if (!clientData) return <div style={{padding:'32px', textAlign:'center', color:'#6B7280'}}>Chargement...</div>;

  const affairesClient = affaires.filter(a => a.client_id === clientData.id);
  const devisClient = devis.filter(d => affairesClient.some(a => a.id === d.affaire_id));
  const facturesClient = factures.filter(f => affairesClient.some(a => a.id === f.affaire_id));
  const totalFacture = facturesClient.reduce((s,f) => s + parseFloat(f.montant_ht||0), 0);
  const totalPaye = facturesClient.reduce((s,f) => s + (parseFloat(f.montant_ht||0) - parseFloat(f.solde_restant||0)), 0);

  const badge = (s) => ({
    display:'inline-block', padding:'3px 10px', borderRadius:'20px', fontSize:'12px', fontWeight:'600',
    background: s==='ouverte'||s==='accepte' ? '#DCFCE7' : s==='brouillon'||s==='en_cours' ? '#FEF9C3' : s==='payee' ? '#EDE9FE' : s==='emise' ? '#DBEAFE' : '#F3F4F6',
    color: s==='ouverte'||s==='accepte' ? '#16A34A' : s==='brouillon'||s==='en_cours' ? '#CA8A04' : s==='payee' ? '#7C3AED' : s==='emise' ? '#1D4ED8' : '#6B7280'
  });

  const s = {
    card: { background:'white', borderRadius:'10px', padding:'24px', boxShadow:'0 2px 8px rgba(0,0,0,0.08)', marginBottom:'16px' },
    th: (c) => ({ background:c||COLORS.bleu, color:'white', padding:'10px 14px', textAlign:'left', fontSize:'13px' }),
    td: { padding:'10px 14px', borderBottom:'1px solid #F3F4F6', fontSize:'14px' },
    label: { fontSize:'12px', color:'#6B7280', textTransform:'uppercase', marginBottom:'4px' },
    value: { fontSize:'14px', color:'#1F2937', fontWeight:'500' },
    input: { width:'100%', padding:'7px 10px', border:'1px solid #D1D5DB', borderRadius:'6px', fontSize:'14px', boxSizing:'border-box' },
    btn: (c) => ({ background:c, color:'white', border:'none', padding:'8px 16px', borderRadius:'8px', cursor:'pointer', fontSize:'14px', fontWeight:'600' }),
  };

  // Rend un triplet adresse / code postal / ville. Le champ adresse est autocomplété via
  // la BAN : choisir une suggestion préremplit aussi le code postal et la ville.
  const champsAdresse = (adresseField, cpField, villeField) => {
    const fields = [
      { label: 'Adresse', field: adresseField },
      { label: 'Code postal', field: cpField },
      { label: 'Ville', field: villeField },
    ];
    return (
      <div style={{display:'grid', gridTemplateColumns:'2fr 1fr 1fr', gap:'12px'}}>
        {fields.map(({ label, field }, i) => (
          <div key={field}>
            <div style={s.label}>{label}</div>
            {!editMode ? <div style={s.value}>{clientData[field]||'—'}</div>
              : i === 0 ? (
                <AdresseAutocomplete apiFetch={apiFetch} value={form[field]} inputStyle={s.input} placeholder={label}
                  onChangeText={v => setForm(f => ({...f, [field]: v}))}
                  onPick={sg => setForm(f => ({
                    ...f,
                    [adresseField]: sg.adresse || f[adresseField],
                    [cpField]: sg.code_postal || f[cpField],
                    [villeField]: sg.ville || f[villeField],
                  }))} />
              ) : (
                <input style={s.input} value={form[field]||''} onChange={e => setForm({...form, [field]:e.target.value})} placeholder={label} />
              )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div>
      {message && <div style={{position:'fixed', top:'20px', right:'20px', background:COLORS.bleu, color:'white', padding:'12px 20px', borderRadius:'8px', zIndex:2000}}>{message}</div>}

      <div style={{display:'flex', alignItems:'center', gap:'12px', marginBottom:'24px', flexWrap:'wrap'}}>
        <button onClick={onRetour} style={{background:'#E5E7EB', border:'none', padding:'8px 16px', borderRadius:'8px', cursor:'pointer', fontSize:'14px'}}>← Retour</button>
        <h2 style={{margin:0, color:COLORS.bleu, fontSize:'20px'}}>
          {clientData.est_professionnel ? '🏢' : '👤'} {clientData.nom} {clientData.prenom||''}
        </h2>
        <div style={{marginLeft:'auto', display:'flex', gap:'8px'}}>
          {!editMode && peutEcrire && <button style={s.btn('#6B7280')} onClick={() => setEditMode(true)}>✏️ Modifier</button>}
          {editMode && <>
            <button style={s.btn('#6B7280')} onClick={() => { setEditMode(false); setForm({...clientData}); }}>✕ Annuler</button>
            <button style={s.btn(COLORS.vert)} onClick={sauvegarder} disabled={saving}>{saving ? 'Sauvegarde...' : '✅ Sauvegarder'}</button>
          </>}
        </div>
      </div>

      <div style={{display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gap:'12px', marginBottom:'20px'}}>
        {[
          { label:'Affaires', val: affairesClient.length, color: COLORS.brun },
          { label:'Devis', val: devisClient.length, color: COLORS.orange },
          { label:'Facturé HT', val: `${totalFacture.toFixed(2)} €`, color: COLORS.vert },
          { label:'Restant dû', val: `${(totalFacture-totalPaye).toFixed(2)} €`, color: '#DC2626' },
        ].map(({label, val, color}) => (
          <div key={label} style={{background:'white', borderRadius:'8px', padding:'16px', boxShadow:'0 2px 6px rgba(0,0,0,0.08)', borderTop:`3px solid ${color}`}}>
            <div style={{fontSize:'11px', color:'#6B7280', textTransform:'uppercase', marginBottom:'4px'}}>{label}</div>
            <div style={{fontSize:'22px', fontWeight:'700', color}}>{val}</div>
          </div>
        ))}
      </div>

      {/* Informations générales */}
      <div style={{...s.card, padding:0, overflow:'hidden'}}>
        <div onClick={() => !editMode && toggleSection('infos')}
          style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'14px 20px', background:'#F9FAFB', borderBottom: (editMode || sectionsOuvertes.infos) ? '1px solid #E5E7EB' : 'none', cursor: editMode ? 'default' : 'pointer'}}>
          <h4 style={{margin:0, color:COLORS.bleu, fontSize:'14px', fontWeight:'700'}}>👤 Informations client</h4>
          {!editMode && <span style={{color:'#9CA3AF', fontSize:'16px'}}>{sectionsOuvertes.infos ? '▾' : '▸'}</span>}
        </div>
      {(editMode || sectionsOuvertes.infos) && <div style={{padding:'20px'}}>
        <div style={{display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:'16px'}}>
          {[
            { label:'Nom', field:'nom' },
            { label:'Prénom', field:'prenom' },
            { label:'Téléphone', field:'telephone' },
            ...(!clientData.est_professionnel ? [{ label:'Téléphone 2', field:'telephone_2' }] : []),
            { label:'Email', field:'email' },
            { label:'Nom entreprise', field:'nom_entreprise' },
            { label:'SIRET', field:'siret' },
          ].map(({label, field}) => (
            <div key={field}>
              <div style={s.label}>{label}</div>
              {editMode
                ? <input style={s.input} value={form[field]||''} onChange={e => setForm({...form, [field]:e.target.value})} placeholder={label} />
                : <div style={s.value}>{clientData[field]||'—'}</div>
              }
              {field === 'siret' && clientData.est_professionnel && !(editMode ? form.siret : clientData.siret) && (
                <div style={{fontSize:'11px', color:'#D97706', marginTop:'4px'}}>
                  ℹ️ Deviendra obligatoire pour facturer ce client (réforme facturation électronique, échéance 2027)
                </div>
              )}
            </div>
          ))}
          <div>
            <div style={s.label}>Type</div>
            {editMode
              ? <select style={s.input} value={form.est_professionnel||false} onChange={e => setForm({...form, est_professionnel: e.target.value==='true'})}>
                  <option value={false}>👤 Particulier</option>
                  <option value={true}>🏢 Professionnel</option>
                </select>
              : <div style={s.value}>{clientData.est_professionnel ? '🏢 Professionnel' : '👤 Particulier'}</div>
            }
          </div>
        </div>
      </div>
      }
      </div>

      {/* Adresses — section repliable */}
      <div style={{...s.card, padding:0, overflow:'hidden'}}>
        <div onClick={() => !editMode && toggleSection('adresses')}
          style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'14px 20px', background:'#F9FAFB', borderBottom: (editMode || sectionsOuvertes.adresses) ? '1px solid #E5E7EB' : 'none', cursor: editMode ? 'default' : 'pointer'}}>
          <h4 style={{margin:0, color:COLORS.bleu, fontSize:'14px', fontWeight:'700'}}>🏠 Adresses</h4>
          {!editMode && <span style={{color:'#9CA3AF', fontSize:'16px'}}>{sectionsOuvertes.adresses ? '▾' : '▸'}</span>}
        </div>
        {(editMode || sectionsOuvertes.adresses) && <div style={{padding:'20px'}}>
          <div style={{fontSize:'13px', fontWeight:'600', color:'#374151', marginBottom:'8px'}}>Adresse principale</div>
          <div style={{marginBottom:'16px'}}>{champsAdresse('adresse', 'code_postal', 'ville')}</div>
          <div style={{fontSize:'13px', fontWeight:'600', color:'#374151', marginBottom:'8px'}}>Adresse de facturation <span style={{fontWeight:'400', color:'#9CA3AF'}}>(si différente)</span></div>
          <div style={{marginBottom:'16px'}}>{champsAdresse('adresse_facturation', 'cp_facturation', 'ville_facturation')}</div>
          <div style={{fontSize:'13px', fontWeight:'600', color:COLORS.brun, marginBottom:'8px'}}>📍 Adresses chantier</div>
          {[1,2,3].map(n => (
            <div key={n} style={{marginBottom: n < 3 ? '12px' : 0}}>
              <div style={{fontSize:'12px', color:'#6B7280', marginBottom:'6px'}}>Chantier {n}</div>
              {champsAdresse(`adresse_chantier_${n}`, `cp_chantier_${n}`, `ville_chantier_${n}`)}
            </div>
          ))}
        </div>}
      </div>

      {/* Contacts — section repliable (pro uniquement) */}
      {clientData.est_professionnel && (
        <div style={{...s.card, padding:0, overflow:'hidden'}}>
          <div onClick={() => !editMode && toggleSection('contacts')}
            style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'14px 20px', background:'#F9FAFB', borderBottom: (editMode || sectionsOuvertes.contacts) ? '1px solid #E5E7EB' : 'none', cursor: editMode ? 'default' : 'pointer'}}>
            <h4 style={{margin:0, color:COLORS.bleu, fontSize:'14px', fontWeight:'700'}}>📞 Contacts</h4>
            {!editMode && <span style={{color:'#9CA3AF', fontSize:'16px'}}>{sectionsOuvertes.contacts ? '▾' : '▸'}</span>}
          </div>
          {(editMode || sectionsOuvertes.contacts) && <div style={{padding:'20px'}}>
            {[1,2,3].map(n => {
              const hasData = clientData[`contact_${n}_nom`] || clientData[`contact_${n}_prenom`] || clientData[`contact_${n}_telephone`] || (n === 1 && clientData.nom_entreprise);
              if (!editMode && !hasData && n > 1) return null;
              return (
                <div key={n} style={{marginBottom: n < 3 ? '16px' : 0, paddingBottom: n < 3 ? '16px' : 0, borderBottom: n < 3 ? '1px solid #F3F4F6' : 'none'}}>
                  <div style={{fontSize:'13px', fontWeight:'600', color:'#374151', marginBottom:'8px'}}>Contact {n}</div>
                  <div style={{display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:'12px'}}>
                    <div>
                      <div style={s.label}>Nom</div>
                      {editMode ? <input style={s.input} value={n===1?(form.nom_entreprise||''):(form[`contact_${n}_nom`]||'')} onChange={e => setForm({...form, [n===1?'nom_entreprise':`contact_${n}_nom`]:e.target.value})} placeholder="Nom" />
                        : <div style={s.value}>{(n===1?clientData.nom_entreprise:clientData[`contact_${n}_nom`])||'—'}</div>}
                    </div>
                    <div>
                      <div style={s.label}>Prénom</div>
                      {editMode ? <input style={s.input} value={n===1?(form.prenom||''):(form[`contact_${n}_prenom`]||'')} onChange={e => setForm({...form, [n===1?'prenom':`contact_${n}_prenom`]:e.target.value})} placeholder="Prénom" />
                        : <div style={s.value}>{(n===1?clientData.prenom:clientData[`contact_${n}_prenom`])||'—'}</div>}
                    </div>
                    <div>
                      <div style={s.label}>Poste / Rôle</div>
                      {editMode ? <input style={s.input} value={form[`contact_${n}_poste`]||''} onChange={e => setForm({...form, [`contact_${n}_poste`]:e.target.value})} placeholder="Ex: Conducteur de travaux" />
                        : <div style={s.value}>{clientData[`contact_${n}_poste`]||'—'}</div>}
                    </div>
                    <div>
                      <div style={s.label}>Téléphone direct</div>
                      {editMode ? <input style={s.input} value={form[`contact_${n}_telephone`]||''} onChange={e => setForm({...form, [`contact_${n}_telephone`]:e.target.value})} placeholder="06 XX XX XX XX" />
                        : <div style={s.value}>{clientData[`contact_${n}_telephone`]||'—'}</div>}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>}
        </div>
      )}

      {/* Notes — section repliable */}
      <div style={{...s.card, padding:0, overflow:'hidden'}}>
        <div onClick={() => !editMode && toggleSection('notes')}
          style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'14px 20px', background:'#F9FAFB', borderBottom: (editMode || sectionsOuvertes.notes) ? '1px solid #E5E7EB' : 'none', cursor: editMode ? 'default' : 'pointer'}}>
          <h4 style={{margin:0, color:COLORS.bleu, fontSize:'14px', fontWeight:'700'}}>📝 Notes {!editMode && clientData.notes && <span style={{fontSize:'12px', color:'#6B7280', fontWeight:'400', marginLeft:'8px'}}>({clientData.notes.length} car.)</span>}</h4>
          {!editMode && <span style={{color:'#9CA3AF', fontSize:'16px'}}>{sectionsOuvertes.notes ? '▾' : '▸'}</span>}
        </div>
        {(editMode || sectionsOuvertes.notes) && <div style={{padding:'20px'}}>
          {editMode
            ? <textarea style={{...s.input, minHeight:'100px', resize:'vertical', fontFamily:'inherit'}} value={form.notes||''} onChange={e => setForm({...form, notes:e.target.value})} placeholder="Notes libres sur ce client..." />
            : <div style={{...s.value, whiteSpace:'pre-wrap', color: clientData.notes ? '#1F2937' : '#9CA3AF'}}>{clientData.notes || 'Aucune note'}</div>
          }
        </div>}
      </div>

      <div style={s.card}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px'}}>
          <h4 style={{color:COLORS.brun, margin:0, fontSize:'15px'}}>🔨 Affaires ({affairesClient.length})</h4>
          {!editMode && peutEcrire && <button style={s.btn(COLORS.brun)} onClick={onNouvelleAffaire}>+ Nouvelle affaire</button>}
        </div>
        {affairesClient.length === 0
          ? <p style={{color:'#9CA3AF', fontSize:'14px'}}>Aucune affaire{peutEcrire && <> — <button onClick={onNouvelleAffaire} style={{background:'none', border:'none', color:COLORS.brun, cursor:'pointer', fontWeight:'600', fontSize:'14px'}}>créer la première →</button></>}</p>
          : <table style={{width:'100%', borderCollapse:'collapse'}}>
              <thead><tr>{['Référence','Titre','Ville','Statut',''].map(h => <th key={h} style={s.th(COLORS.brun)}>{h}</th>)}</tr></thead>
              <tbody>
                {affairesClient.map((a,i) => (
                  <tr key={a.id} style={{background: i%2===0?'white':'#F9FAFB', cursor: onOuvrirAffaire ? 'pointer' : 'default'}}
                    onClick={() => onOuvrirAffaire && onOuvrirAffaire(a)}>
                    <td style={{...s.td, fontWeight:'600', color:COLORS.brun}}>{a.reference}</td>
                    <td style={{...s.td, fontWeight:'500'}}>{a.titre}</td>
                    <td style={s.td}>{a.ville_chantier||'—'}</td>
                    <td style={s.td}><span style={badge(a.statut)}>{a.statut}</span></td>
                    <td style={{...s.td, textAlign:'right'}}>
                      <span style={{fontSize:'12px', color:'#9CA3AF'}}>Ouvrir →</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
        }
      </div>

      <div style={s.card}>
        <h4 style={{color:COLORS.orange, margin:'0 0 16px 0', fontSize:'15px'}}>📋 Devis ({devisClient.length})</h4>
        {devisClient.length === 0
          ? <p style={{color:'#9CA3AF', fontSize:'14px'}}>Aucun devis</p>
          : <table style={{width:'100%', borderCollapse:'collapse'}}>
              <thead><tr>{['Référence','Affaire','Statut','Date',''].map(h => <th key={h} style={s.th(COLORS.orange)}>{h}</th>)}</tr></thead>
              <tbody>
                {devisClient.map((d,i) => (
                  <tr key={d.id} style={{background: i%2===0?'white':'#F9FAFB'}}>
                    <td style={{...s.td, fontWeight:'600'}}>{d.reference}</td>
                    <td style={s.td}>{affairesClient.find(a=>a.id===d.affaire_id)?.titre||'—'}</td>
                    <td style={s.td}><span style={badge(d.statut_global)}>{d.statut_global}</span></td>
                    <td style={s.td}>{new Date(d.created_at).toLocaleDateString('fr-FR')}</td>
                    <td style={s.td}>
                      {onOuvrirDevis && (
                        <button style={{background:'none', border:'1px solid #D1D5DB', padding:'3px 10px', borderRadius:'6px', cursor:'pointer', fontSize:'12px', color:'#374151'}}
                          onClick={() => onOuvrirDevis(d.id)}>
                          Ouvrir →
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
        }
      </div>

      <div style={s.card}>
        <h4 style={{color:COLORS.vert, margin:'0 0 16px 0', fontSize:'15px'}}>📄 Factures ({facturesClient.length})</h4>
        {facturesClient.length === 0
          ? <p style={{color:'#9CA3AF', fontSize:'14px'}}>Aucune facture</p>
          : <table style={{width:'100%', borderCollapse:'collapse'}}>
              <thead><tr>{['Numéro','Affaire','Montant HT','Solde','Statut',''].map(h => <th key={h} style={s.th(COLORS.vert)}>{h}</th>)}</tr></thead>
              <tbody>
                {facturesClient.map((f,i) => {
                  const affaire = affairesClient.find(a=>a.id===f.affaire_id);
                  return (
                  <tr key={f.id} style={{background: i%2===0?'white':'#F9FAFB'}}>
                    <td style={{...s.td, fontWeight:'600'}}>{f.numero}</td>
                    <td style={s.td}>{affaire?.titre||'—'}</td>
                    <td style={s.td}>{parseFloat(f.montant_ht).toFixed(2)} €</td>
                    <td style={s.td}>{parseFloat(f.solde_restant).toFixed(2)} €</td>
                    <td style={s.td}><span style={badge(f.statut)}>{f.statut}</span></td>
                    <td style={s.td}>
                      {onOuvrirAffaire && affaire && (
                        <button style={{background:'none', border:'1px solid #D1D5DB', padding:'3px 10px', borderRadius:'6px', cursor:'pointer', fontSize:'12px', color:'#374151'}}
                          onClick={() => onOuvrirAffaire(affaire)}>
                          Affaire →
                        </button>
                      )}
                    </td>
                  </tr>
                  );
                })}
              </tbody>
            </table>
        }
      </div>
    </div>
  );
}
